module.exports = __webpack_public_path__ + "static/media/74325825_2147333802037108_2032018503128580096_o.ae05167d.png";